"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("../../styles/antd.min.css");

require("../../styles/jodit.min.css");

var _AdminRouter = _interopRequireDefault(require("./AdminRouter"));

var _PreviewRouter = _interopRequireDefault(require("./PreviewRouter"));

var _PrivateRouter = _interopRequireDefault(require("./PrivateRouter"));

var _Loader = _interopRequireDefault(require("../Loader"));

var _useAuth = _interopRequireDefault(require("../../hooks/useAuth"));

var _useSite = _interopRequireDefault(require("../../hooks/useSite"));

var _auth = require("../../utils/auth");

var _redux = require("../../redux"); // import external css files
// import components


var Router = function Router(props) {
  var _authUser$capabilitie, _authUser$capabilitie2;

  var config = props.config;

  var _ref = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      authUser = _ref.auth.user;

  var dispatch = (0, _redux.useAppDispatch)();
  (0, _react.useEffect)(function () {
    dispatch(_redux.cmsActions.setConfig(config));
  }, []);
  (0, _useAuth.default)();
  (0, _useSite.default)();

  if ((0, _auth.getPreviewID)()) {
    return /*#__PURE__*/_react.default.createElement(_PreviewRouter.default, props);
  } else if (authUser !== null && authUser !== void 0 && (_authUser$capabilitie = authUser.capabilities) !== null && _authUser$capabilitie !== void 0 && _authUser$capabilitie.edit_posts) {
    return /*#__PURE__*/_react.default.createElement(_AdminRouter.default, props);
  } else if (authUser !== null && authUser !== void 0 && (_authUser$capabilitie2 = authUser.capabilities) !== null && _authUser$capabilitie2 !== void 0 && _authUser$capabilitie2.read) {
    return /*#__PURE__*/_react.default.createElement(_PrivateRouter.default, props);
  } else {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
};

var _default = Router;
exports.default = _default;